import { render, staticRenderFns } from "./OmxTopbar.vue?vue&type=template&id=70c030f2&scoped=true"
import script from "./OmxTopbar.vue?vue&type=script&lang=js"
export * from "./OmxTopbar.vue?vue&type=script&lang=js"
import style0 from "./OmxTopbar.vue?vue&type=style&index=0&id=70c030f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c030f2",
  null
  
)

export default component.exports